<template>
    <div class="content-box">
        <Title/>

        <Echarts/>
    </div>
</template>

<script>
export default {
    name: "logistics",
    data() {
        return {
            params: {
                dataNav: [
                    {
                        name: "市场规模",
                        data: "a103",
                        unit: "亿元"
                    },
                ],
                name: '跨境物流'
            }
        }
    },
    created() {
        this.$store.dispatch('getIndustry', this.params)
    }
}
</script>